module.exports = __webpack_public_path__ + "img/full3-min.0b15a918.png";